import React, { useState, useEffect } from 'react'
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { IoIosArrowForward } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import { FaWallet } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";

// Helper to decode JWT (basic approach, use a library for production)
function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return {};
    }
}

function getUserIdFromLocalStorage() {
    const token = localStorage.getItem('token');
    const decoded = decodeToken(token);
    // Adjust this according to your JWT schema (id, userId, etc)
    return decoded && (decoded.id || decoded.userId || decoded._id);
}

// Fetch wallet balance for a client via new API
async function fetchWalletBalanceForClient(clientId) {
    const token = localStorage.getItem('token');
    if (!clientId || !token) return null;

    try {
        // Correct endpoint for client_meta (not usermeta)
        // E.g., 'https://wa-api.globebot.io/auth/client_meta/' + clientId
        const response = await fetch(`https://wa-api.globebot.io/auth/client/${clientId}/meta`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) return null;
        const data = await response.json();
        // API returns: { "meta": [ { "id": 8, "meta_key": "wallet", "meta_value": "279522" } ] }
        if (
            data.meta &&
            Array.isArray(data.meta)
        ) {
            const walletMeta = data.meta.find((metaItem) => metaItem.meta_key === "wallet");
            if (walletMeta && walletMeta.meta_value !== undefined) {
                return walletMeta.meta_value;
            }
        }
        return null;
    } catch (e) {
        return null;
    }
}

function ClientList() {
    const [showfilter, setshowfilter] = useState(false);
    const [username, setusername] = useState('');
    const [MobileNumber, setMobileNumber] = useState('');
    const [EmailId, setEmailId] = useState('');
    // --- Change "showbalance" to store only the unique id of the user whose wallet popup is open
    const [showbalanceId, setShowbalanceId] = useState(null);
    const [walletLoading, setWalletLoading] = useState(false);
    const [walletError, setWalletError] = useState("");
    const [walletAmount, setWalletAmount] = useState(null);

    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [usersperpage, setuserperpages] = useState(10);

    // Get clients assigned by the logged-in user
    useEffect(() => {
        const fetchClients = async () => {
            // Get logged-in user id from localStorage token
            const loggedInUserId = getUserIdFromLocalStorage();
            if (!loggedInUserId) {
                setUsers([]);
                setFilteredUsers([]);
                return;
            }

            try {
                // Use actual API endpoint
                const token = localStorage.getItem('token');
                const response = await fetch('https://wa-api.globebot.io/auth/client', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                const allClients = await response.json();

                // Filter where AssignedBy === loggedInUserId (may be AssignedBy or assignedBy based on backend, adjust if needed)
                const assignedClients = allClients.filter(client =>
                    String(client.AssignedBy || client.assignedBy) === String(loggedInUserId)
                );
                // console.log("loggedInUserId",loggedInUserId);
                // console.log("assignedClients",assignedClients);
                setUsers(assignedClients);
                setFilteredUsers(assignedClients);
            } catch (e) {
                setUsers([]);
                setFilteredUsers([]);
            }
        };
        fetchClients();
    }, []);

    // Filtering logic (from filter form)
    useEffect(() => {
        let _users = [...users];
        if (username) {
            _users = _users.filter(u =>
                u.name && u.name.toLowerCase().includes(username.toLowerCase())
            );
        }
        if (MobileNumber) {
            _users = _users.filter(u =>
                u.phone && u.phone.includes(MobileNumber)
            );
        }
        if (EmailId) {
            _users = _users.filter(u =>
                u.email && u.email.toLowerCase().includes(EmailId.toLowerCase())
            );
        }
        setFilteredUsers(_users);
        setcurrentPage(1); // reset pagination on filter
    }, [username, MobileNumber, EmailId, users]);

    const indexoflastuser = currentPage * usersperpage;
    const indexoffirstuser = indexoflastuser - usersperpage;
    const pageUsers = filteredUsers.slice(indexoffirstuser, indexoflastuser);
    const totalpages = Math.ceil(filteredUsers.length / usersperpage);

    // Handler to show wallet info - will call the wallet API, now using client id (not user id)
    const handleShowWallet = async (user) => {
        setWalletLoading(true);
        setWalletError("");
        setWalletAmount(null);

        // Use client id for client_meta API
        // const clientId = user.ClientId || user.clientId || user._id || user.id; // Try all likely fields

        // Set just the user's unique id (clientId or equivalent) rather than the user object
        setShowbalanceId(user);

        try {
            const wallet = await fetchWalletBalanceForClient(user);
            setWalletAmount(wallet);
            if (wallet === null) setWalletError("Unable to get wallet data");
        } catch (e) {
            setWalletError("Unable to get wallet data");
            setWalletAmount(null);
        } finally {
            setWalletLoading(false);
        }
    };

    // hide wallet info popup & reset wallet state
    const closeWallet = () => {
        setShowbalanceId(null);
        setWalletAmount(null);
        setWalletError("");
        setWalletLoading(false);
    };

    return (
        <>
            <div className='pt-[70px] px-2 dark:bg-[#121519] h-[100vh]'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Client List</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward />
                        <span>Clint List</span> </div>
                </div>
                <div onClick={() => setshowfilter(!showfilter)}
                    className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter &&
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519] z-20'>
                        <div className='w-[100%] flex flex-wrap gap-4'>

                            <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>UserName :</label>
                                <input
                                    value={username}
                                    onChange={(e) => setusername(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    placeholder='Enter User Name'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Mobile Number</label>
                                <input
                                    value={MobileNumber}
                                    onChange={(e) => setMobileNumber(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    placeholder='Enter Mobile Number'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Email Id </label>
                                <input
                                    value={EmailId}
                                    onChange={(e) => setEmailId(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    placeholder='Enter Email Id'
                                    type="text"
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[32%] flex items-center gap-1 mt-4'>
                                <button
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                                    onClick={() => { /* Filtering happens automatically via useEffect */ }}
                                >
                                    <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                                </button>
                                <button
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                    onClick={() => {
                                        setusername('');
                                        setMobileNumber('');
                                        setEmailId('');
                                    }}
                                >
                                    <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>
                }
                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] relative ">
                    <thead className="">
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>UserName</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Mobile number</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Email Id</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Is Active</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Registration Date</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Expiry Date</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Check Balance</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageUsers.length > 0 ? (
                            pageUsers.map((user) => {
                                // Unique id for the user row and for popup match
                                const userId = user.ClientId || user.clientId || user._id || user.id;
                                return (
                                    <React.Fragment key={user._id || user.id}>
                                        <tr
                                            className="text-gray-500 odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
                                        >
                                            <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.name}</td>
                                            <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.Mobile}</td>
                                            <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">{user.email}</td>
                                            <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] "><FaCheckCircle className='text-[#448c74] text-[16px]' /></td>
                                            <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                                {user.created
                                                    ? new Date(user.created).toLocaleDateString('en-IN', {
                                                        year: 'numeric',
                                                        month: 'short',
                                                        day: '2-digit'
                                                    })
                                                    : ''}
                                            </td>
                                            <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                                {user.Expiry
                                                    ? new Date(user.Expiry).toLocaleDateString('en-IN', {
                                                        year: 'numeric',
                                                        month: 'short',
                                                        day: '2-digit'
                                                    })
                                                    : ''}
                                            </td>
                                            <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">
                                                <div className='border-[1px] border-[#3f7fc8] p-2  hover:bg-[#3f7fc8] hover:text-[#fff] text-[#3f7fc8] w-[30px] flex justify-center items-center text-[12px] rounded-md'>
                                                    <FaWallet onClick={() => handleShowWallet(user.id)} style={{ cursor: 'pointer' }} />
                                                </div>
                                            </td>
                                        </tr>
                                        {showbalanceId === userId && (
                                            <tr>
                                                <td colSpan={7} style={{ background: "#fff" }}>
                                                    <div className='w-[180px] p-2 rounded-md bg-[#fff] absolute top-[0px] right-[200px] z-50 border-[1px] border-[#0000002c] shadow-lg'>
                                                        <div className='flex w-[100%] justify-between items-center border-b-[1px] border-[#0000002c] pb-2'>
                                                            <span className='text-[#000] text-[12px] font-bold'>Wallet Info</span>
                                                            <RxCross2 style={{ cursor: 'pointer' }} onClick={closeWallet} />
                                                        </div>
                                                        <div className='border-[1px] border-[#0000002c] p-2 w-[100%] rounded-md mt-2'>
                                                            <span className='text-[12px] text-[#448c74] font-semibold'>
                                                                Available Balance
                                                            </span>
                                                            {walletLoading ? (
                                                                <span className='text-[12px] ml-2 text-gray-600 font-semibold'>Loading...</span>
                                                            ) : walletError ? (
                                                                <span className='text-[12px] ml-2 text-red-500 font-semibold'>0</span>
                                                            ) : (
                                                                <span className='text-[12px] ml-2 text-[#448c74] font-semibold'>
                                                                    {walletAmount !== null ? walletAmount : "--"}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })
                        ) : (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="7" className="p-1 text-[11px]">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className='flex justify-between w-[100%] '>
                    <p className='text-[11px] text-[#3f7fc8] mt-2' >
                        Showing {filteredUsers.length === 0 ? 0 : indexoffirstuser + 1} to {filteredUsers.length < indexoflastuser ? filteredUsers.length : indexoflastuser} of {filteredUsers.length} records
                    </p>
                    <div className="flex justify-center mt-4 space-x-3 relative z-0">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => setcurrentPage((prev) => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition "
                        >
                            Prev
                        </button>
                        <p className='text-[11px] text-[#3f7fc8] mt-2' > {currentPage} page of  {totalpages}  pages</p>
                        <button
                            disabled={currentPage === totalpages || totalpages === 0}
                            onClick={() => setcurrentPage((prev) => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ClientList
